import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { connect, MqttClient } from 'mqtt';
import { toast } from 'react-toastify';
import { mqttMessage } from '../store/slice/mqtt.slice';
import {
  selectApiAccessToken,
  selectIsLoggedIn,
  selectMqtt,
} from '../store/api';

export const useMQTT = () => {
  const mqtt = useSelector(selectMqtt);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const token = useSelector(selectApiAccessToken);
  const dispatch = useDispatch();
  const [mqttClient, setMqttClient] = useState<MqttClient | null>(null);

  useEffect(() => {
    if (isLoggedIn) {
      if (!mqttClient && mqtt?.endpoint) {
        const mqttEndpoint = mqtt?.endpoint;
        const client = connect(
          mqttEndpoint.match(/localhost/g)
            ? `ws://${mqttEndpoint}`
            : `wss://${mqttEndpoint}/mqtt?x-amz-customauthorizer-name=mqtt-auth&token=${token}`
          // mqtt?.session_id ? {
          //   clean: false,
          //   clientId: mqtt.session_id,
          // } : {} //persistent sessions to guarantee Qos 1 messages
        );

        setMqttClient(client);
        client.on('reconnect', () => {
          console.info('reconnecting mqtt');
          client.subscribe(
            mqtt.event_topic || '',
            { qos: 1 },
            function (error: any) {
              if (error) {
                toast.error('Live connections lost, please refresh the page.', {
                  autoClose: false,
                });
                // TODO: Need to log this to AWS Cloudwatch along with most other toasts
              }
            }
          );
        });
        client.on('error', (error: any) => {
          console.info('mqtt error');
        });
        client.on('close', (error: any) => {
          console.info('mqtt closed');
        });
        client.on('connect', function () {
          client.subscribe(
            mqtt.event_topic || '',
            { qos: 1 },
            function (error: any) {
              if (error) {
                toast.error('Live connections lost, please refresh the page.', {
                  autoClose: false,
                });
                // TODO: Need to log this to AWS Cloudwatch along with most other toasts
              }
            }
          );
        });

        client.on('message', function (topic: any, data: any) {
          const { message } = JSON.parse(data.toString());
          dispatch(mqttMessage(message));
          return;
        });
      }
    } else {
      if (mqttClient) {
        mqttClient.end();
        setMqttClient(null);
      }
    }
  }, [isLoggedIn, mqtt]); // eslint-disable-line
};
